<template>
  <div>
    <Head title="Descargar"></Head>
    <!-- Start form -->
    <div class="container pt-2 pt-lg-4">
      <div class="lpg-form px-3">
        <div
          class="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-center mb-3"
        >
          <div>
            <h2 class="lpg-form-title text-start m-0">Ofertas con aplicantes</h2>
          </div>
          <div v-if="auth_token.auth_token">
            <div v-if="data.length">
              <a
                class="btn btn-secondary mx-auto "
                :href="
                  'https://bolsadetrabajo.laprensagrafica.com/cvexcel/?cid=' +
                    company_id +
                    '&auth=' +
                    auth_token.auth_token
                "
              >
                Descargar todo
                <i class="bi bi-file-earmark-arrow-down-fill" style="font-size: 2rem;"></i>
              </a>
            </div>
          </div>
        </div>
        <hr />
        <div class="lpg-content-list-2" v-if="data.length">
          <div class="lpg-list-item py-3 px-3" v-for="(element, key) in data" :key="key">
            <div v-if="auth_token.auth_token">
              <a
                style="text-decoration: none;color: black;"
                target="_blank"
                :href="
                  'https://bolsadetrabajo.laprensagrafica.com/cvexcel/?jpid=' +
                    element.job_id +
                    '&cid=' +
                    element.id_company +
                    '&auth=' +
                    auth_token.auth_token
                "
              >
                <div class="d-flex align-items-center justify-content-between flex-row">
                  <p class="m-0 pe-3">
                    <span>{{ element.title }}</span>
                  </p>
                  <p class="m-0 pe-3 ">
                    <span style="font-weight: bolder;">Aplicantes: {{ element.aplicaciones }}</span>
                    <span style="font-weight: bolder;">Vacantes: {{ element.vacancies }}</span>
                  </p>
                  <i class="bi bi-file-earmark-arrow-down-fill" style="font-size: 2rem;"></i>
                </div>
              </a>
            </div>
            <div v-else>
              <div class="d-flex align-items-center justify-content-between flex-row">
                <p class="m-0 pe-3">
                  <span>{{ element.title }}</span>
                </p>
                <p class="m-0 pe-3 ">
                  <span style="font-weight: bolder;">Aplicantes: {{ element.aplicaciones }}</span>
                  <span style="font-weight: bolder;">Vacantes: {{ element.vacancies }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End form -->
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas.vue'

export default {
  name: 'Descargar',
  layout: LayoutEmpresas,
  components: { Head },
  props: {
    data: Array,
    company_id: Number,
    auth_token: Object,
  },
}
</script>

<style scoped></style>
